import styled, { css } from 'styled-components'

export const Root = styled.div`
  background-image: linear-gradient(90deg, #fff73c 0%, #f3ba2f 100%);
`

export const Container = styled.div`
  width: 100%;
  max-width: 1268px;
  margin: 0 auto;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding-right: 15px;
    padding-left: 15px;
  `};
`

export const Title = styled.h2`
  text-align: center;
  font-size: 36px;
  font-weight: normal;
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  text-transform: uppercase;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 22px;
  `};
`

export const Text = styled.p`
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-size: 20px;
  line-height: 1.5;
  font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
  color: #564a27;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 17px;
  `};
`

export const MainSection = styled.div`
  padding: 19px 0px 94px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 48px 0px 26px;
  `};
`

export const ChainsSection = styled.div`
  width: 100%;
  background: #fdf4e1;
`

export const Chains = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  padding: 7px 21px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow-x: scroll;
    padding: 7px 0px;
  `};
`

export const Chain = styled.img`
  margin: 10px 15px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 2px 15px;
  `};
`

export const CountsCards = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 1fr;
  gap: 12px;
  padding: 0px;
  margin: 0;
  margin: 34px 14px 65px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 60px 0px 60px;
  `};
`

export const CountCard = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px 30px;
  border: 3px solid #000000;
  border-radius: 16px;
  background: #fdf4e1cc;
  list-style-type: none;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 15px 5px;
    border-width: 2px;
  `};
`

export const CountCardCount = styled.div`
  font-size: 50px;
  font-weight: bold;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 28px;
  `};
`

export const CountCardText = styled(Text)`
  margin: 0px auto 5px;
  font-size: 16px;
`

export const CallToActionSection = styled.div`
  width: 100%;
  background: white;
`

export const Architecture = styled.div`
  width: 100%;
  margin: 77px 0px;

  & ${Title} {
    margin-bottom: 20px;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 40px 0px;
  `};
`

export const ArchitectureCards = styled.ul`
  display: flex;
  justify-content: stretch;
  margin: 30px 14px 0px;
  padding: 0px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-wrap: wrap;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 30px 0px 0px;
  `};
`

export const ArchitectureCard = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 6px 6px;
  padding: 30px 30px;
  border-radius: 16px;
  background: #fdf4e1cc;
  list-style-type: none;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: calc(50% - 12px);
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    margin: 4px 0px;
  `};
`

export const ArchitectureIcon = styled.img`
  width: 35px;
`

export const ArchitectureCardTitle = styled.h5`
  margin: 13px 0px 10px;
  font-size: 26px;
  text-align: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 20px;
  `};
`

export const ArchitectureText = styled(Text)`
  margin: 0px;
  font-size: 16px;
`

export const CoinsSection = styled.div`
  margin: 140px 20px;
  display: flex;
  align-items: center;

  .coins-section-button-mobile {
    display: none;
  }

  ${({ theme }) => theme.mediaWidth.upToLarge`
    flex-direction: column;
    padding: 40px 20px;
    background: #FDF4E1;
    border-radius: 16px;

    .coins-section-button-mobile {
      display: block;
    }

    .coins-section-button-desktop {
      display: none;
    }
  `};

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 60px 20px;
    padding: 24px 20px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 60px 0px;
  `};
`

export const CoinsInfo = styled.div`
  ${({ theme }) => theme.mediaWidth.upToLarge`
    text-align: center;
  `};
`

export const CoinsText = styled.div`
  margin-bottom: 30px;
  font-size: 42px;
  font-weight: bold;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    margin-bottom: 0px;
    font-size: 22px;
  `};
`

export const CoinsPanelWrapper = styled.div`
  flex-shrink: 0;
  margin-left: 50px;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    margin-left: 0px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    align-self: stretch;
  `};
`

export const Trade = styled.div`
  margin: 151px 20px 147px;
  display: flex;
  border-radius: 20px;
  border: 3px solid #000000;
  overflow: hidden;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 60px 20px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 60px 0px;
  `};
`

export const TradeInfo = styled.div`
  width: 100%;
  padding: 66px 20px;
  padding-left: 5%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-right: 3px solid #000000;
  background: linear-gradient(90deg, #f3ba2f 0%, #fff73c 100%);

  ${({ theme }) => theme.mediaWidth.upToLarge`
    align-items: center;
    padding: 24px 20px;
    border-right: none;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    background: linear-gradient(180deg,#f3ba2f 0%,#fff73c 100%);
  `};
`

export const TradeTitle = styled.h3`
  max-width: 300px;
  margin: 0px;
  margin-bottom: 24px;
  font-size: 45px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 24px;
    margin-left: 20px;
    margin-bottom: 18px;
  `};
`

export const TradeButtons = styled.div``

export const TradeButton = styled.button<{ active: boolean }>`
  margin-bottom: 24px;
  margin-right: 15px;
  padding: 14px 28px 12px;
  border: none;
  border-radius: 31px;
  font-size: 20px;
  background: #fdf4e1;
  color: #564a27;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background: white;
    transition: 0.2s;
  }

  ${props =>
    props.active &&
    css`
      background: #42ce61;
      color: white;
      cursor: default;

      &:hover {
        background: #42ce61;
      }
    `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-right: 8px;
    padding: 12px 16px 8px;
    font-size: 18px;
  `};
`

export const TradeText = styled(Text)`
  margin: 0px;
  margin-bottom: auto;
  max-width: 358px;
  text-align: left;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    margin-bottom: 23px;
    max-width: 600px;
  `};
`

export const TradeImage = styled.img<{ visibility: 'mobile' | 'desktop' }>`
  display: ${props => (props.visibility === 'mobile' ? 'none' : 'block')};
  width: 100%;
  max-width: 736px;
  flex-shrink: 0;

  ${({ theme, visibility }) => theme.mediaWidth.upToLarge`
    display: ${visibility === 'mobile' ? 'flex' : 'none'};
    width: calc(100% + 40px);
    margin: 0px -20px 18px;
  `};
`

export const LeverageSection = styled.div`
  width: 100%;
  background: #fdf4e1;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    background: none;
  `};
`

export const Leverage = styled.div`
  width: 100%;
  padding: 62px 20px 43px;
  display: flex;
  justify-content: center;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 0px;
  `};
`

export const LeverageGIF = styled.img<{ visibility: 'mobile' | 'desktop' }>`
  display: ${props => (props.visibility === 'mobile' ? 'none' : 'block')};
  width: 100%;
  max-width: 420px;

  ${({ theme, visibility }) => theme.mediaWidth.upToMedium`
    display: ${visibility === 'mobile' ? 'block' : 'none'};
    margin-bottom: 18px;
  `};
`

export const LeverageInfo = styled.div`
  margin-left: 18%;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  ${Title} {
    max-width: 500px;
    margin: 0px;
    margin-bottom: 40px;
    text-align: left;
    line-height: 1.5;
  }

  ${Text} {
    max-width: 360px;
    margin: 0px;
    margin-bottom: 56px;
    text-align: left;
    font-size: 28px;
    line-height: 1.2;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0px;
    align-items: center;

    ${Title} {
      margin-bottom: 18px;
      text-align: center;
    }

    ${Text} {
      margin-bottom: 18px;
      text-align: center;
      font-size: 17px;
    }
  `};
`

export const Trusted = styled.div`
  text-align: center;
  margin-top: 54px;
`

export const AuditSection = styled.div`
  width: 100%;
  margin: 81px 0;
  background: #000;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 50px 0;
  `};
`

export const Audit = styled.div`
  display: flex;
  align-items: center;
  padding: 42px 20px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `};
`

export const AuditInfo = styled.div`
  max-width: 500px;
  margin-right: 13%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    text-align: center;
    margin-right: 0px;
  `};
`

export const AuditTitle = styled.h3`
  margin: 0px;
  margin-bottom: 30px;
  font-size: 45px;
  font-family: ${props => props.theme.typography.fontFamily.secondary};
  color: #fdf4e1;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 24px;
    margin-bottom: 24px;
  `};
`

export const AuditLink = styled.a`
  text-decoration: none;
  font-size: 20px;
  color: #f3ba2f;
  transition: 0.2s;
  cursor: pointer;

  svg {
    margin-left: 16px;
    transition: 0.2s;
  }

  svg path {
    fill: #f3ba2f;
    transition: 0.2s;
  }

  &:hover {
    color: #e85a44;

    svg path {
      fill: #e85a44;
    }
  }
`

export const AuditLogo = styled.img<{ visibility: 'mobile' | 'desktop' }>`
  display: ${props => (props.visibility === 'mobile' ? 'none' : 'block')};
  margin: 0 auto;

  ${({ theme, visibility }) => theme.mediaWidth.upToMedium`
    display: ${visibility === 'mobile' ? 'block' : 'none'};
    width: 258px;
    margin-bottom: 24px;
  `};
`

export const PartnersSection = styled.div`
  margin: 91px 0px 0px;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-top: 60px;
  `};
`

export const Partners = styled.div`
  margin-top: 37px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-top: 18px;
  `};
`

export const PartnerLogo = styled.img`
  max-width: 80%;
  max-height: 60%;
`

export const Partner = styled.div`
  width: calc(25% - 10px);
  height: 100px;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: #fdf4e1;

  &[data-partner='zee'] {
    ${PartnerLogo} {
      max-height: 90%;
    }
  }

  &[data-partner='chainlink'],
  &[data-partner='iotex'],
  &[data-partner='heco'],
  &[data-partner='mdex'],
  &[data-partner='dia'],
  &[data-partner='bscNews'],
  &[data-partner='hacken'],
  &[data-partner='metis'],
  &[data-partner='mimo'],
  &[data-partner='zee'] {
    width: calc(20% - 10px);
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    &[data-partner] {
      width: calc(50% - 4px);
      height: 58px;
      margin: 2px;      
    }
  `};
`

export const FooterSection = styled.div`
  margin-top: 158px;
  background: #fdf4e1;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-top: 60px;
  `};
`
